import { AdacDropdownList, AdacInput } from '@adac-de/component-library';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styles from './personal-data-section.module.scss';
import {
  ERROR_MESSAGE,
  CHAR_LIMITATION_ERROR,
  REGEX_EMAIL,
  REGEX_LATIN_ALPHABET,
  REGEX_PHONE,
  PHONE_ERROR
} from './form-variables';

export type PersonalDataFormFields = {
  title: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
};

const titleOptions = [
  { label: 'Herr', value: 'Herr' },
  { label: 'Frau', value: 'Frau' },
  { label: 'Keine', value: 'Keine' }
];

export const PersonalDataSection: React.FC = () => {
  const {
    formState: { errors },
    control,
    register,
    watch
  } = useFormContext<PersonalDataFormFields>();

  //bugfix: to make autofill work we need to watch the inputs
  return (
    <>
      <fieldset className={styles.personalDataGrid} aria-labelledby="personal-data-headline">
        <Controller
          control={control}
          name="title"
          rules={{ required: true }}
          render={({ field }) => (
            <AdacDropdownList
              className={styles.formTitle}
              id="title"
              label="Anrede"
              options={titleOptions}
              value={titleOptions.find(({ value }) => value === field.value)?.label ?? ''}
              onSelect={event => field.onChange(event)}
              propRef={field.ref}
              error={errors.title && ERROR_MESSAGE}
            />
          )}
        />
        <AdacInput
          className={styles.formFirstname}
          id="firstname"
          label="Vorname"
          type="text"
          autoComplete="firstname"
          error={errors.firstname && CHAR_LIMITATION_ERROR}
          {...register('firstname', {
            minLength: 2,
            maxLength: 40,
            pattern: REGEX_LATIN_ALPHABET,
            required: true
          })}
        />
        <AdacInput
          className={styles.formLastname}
          id="lastname"
          label="Nachname"
          type="text"
          autoComplete="lastname"
          error={errors.lastname && CHAR_LIMITATION_ERROR}
          {...register('lastname', {
            minLength: 2,
            maxLength: 40,
            pattern: REGEX_LATIN_ALPHABET,
            required: true
          })}
        />
        <AdacInput
          className={styles.formEmail}
          id="email"
          label="E-Mail"
          type="email"
          autoComplete="email"
          error={errors.email && ERROR_MESSAGE}
          value={watch('email')}
          {...register('email', {
            required: true,
            pattern: REGEX_EMAIL
          })}
        />
        <AdacInput
          className={styles.formPhone}
          id="phone"
          label="Telefonnummer"
          type="tel"
          error={errors.phone && PHONE_ERROR}
          value={watch('phone')}
          {...register('phone', { pattern: REGEX_PHONE, required: true })}
        />
      </fieldset>
    </>
  );
};
